<h2 class="p-gap redesign" style="margin-top: 50px;">Dokumente</h2>
<div class="row">
    <div class="input-field col s12">
        <ul class="collection" style="margin-top:-27px;">
            <li class="collection-item cursor-link" (click)="takeImageClicked('burialorder')">
                <div class="row space-between" style="margin-bottom: 0">
                    <span [ngClass]="{'active': burialDocs.burialorderData}">Antrag auf Ein&auml;scherung</span>

                    <div class="row center" *ngIf="burialDocs.burialorderData">
                        <span class="right" style="margin-right: 25px">
                            <i class="material-icons grey-text text-darken-3">archive</i>
                        </span>

                        <img src="assets/images/RTK_Haken.png" height="18" />
                    </div>
                </div>
            </li>
            <li class="collection-item cursor-link" (click)="takeImageClicked('deathcertificate')">
                <div class="row space-between" style="margin-bottom: 0">
                    <span [ngClass]="{'active': burialDocs.deathcertificateData}">Sterbeurkunde (inkl. Melde-/Sterbefallbescheinigung)</span>

                    <div class="row center" *ngIf="burialDocs.deathcertificateData">
                        <span class="right" style="margin-right: 25px">
                            <i class="material-icons grey-text text-darken-3">archive</i>
                        </span>

                        <img src="assets/images/RTK_Haken.png" height="18" />
                    </div>
                </div>
            </li>
            <li class="collection-item cursor-link" (click)="takeImageClicked('deathapproval')">
                <div class="row space-between" style="margin-bottom: 0">
                    <span [ngClass]="{'active': burialDocs.deathapprovalData}">Erlaubnis zur Einäscherung</span>

                    <div class="row center" *ngIf="burialDocs.deathapprovalData">
                        <span class="right" style="margin-right: 25px">
                            <i class="material-icons grey-text text-darken-3">archive</i>
                        </span>

                        <img src="assets/images/RTK_Haken.png" height="18" />
                    </div>
                </div>
            </li>
            <li class="collection-item cursor-link" (click)="takeImageClicked('deathapprovalsecret')">
                <div class="row space-between" style="margin-bottom: 0">
                    <span [ngClass]="{'active': burialDocs.deathapprovalsecretData}">Todesbescheinigung
                        (vertraulich)</span>

                    <div class="row center" *ngIf="burialDocs.deathapprovalsecretData">
                        <span class="right" style="margin-right: 25px">
                            <i class="material-icons grey-text text-darken-3">archive</i>
                        </span>

                        <img src="assets/images/RTK_Haken.png" height="18" />
                    </div>
                </div>
            </li>
            <li class="collection-item cursor-link" (click)="takeImageClicked('urnrequest')">
                <div class="row space-between" style="margin-bottom: 0">
                    <span [ngClass]="{'active': burialDocs.urnrequestData}">Urnenanforderung</span>

                    <div class="row center" *ngIf="burialDocs.urnrequestData">
                        <span class="right" style="margin-right: 25px">
                            <i class="material-icons grey-text text-darken-3">archive</i>
                        </span>

                        <img src="assets/images/RTK_Haken.png" height="18" />
                    </div>
                </div>
            </li>
            <li class="collection-item cursor-link" (click)="takeImageClicked('stuff')">
                <div class="row space-between" style="margin-bottom: 0">
                    <span [ngClass]="{'active': burialDocs.stuffData}">Sonstige Dokumente</span>

                    <div class="row center" *ngIf="burialDocs.stuffData">
                        <span class="right" style="margin-right: 25px">
                            <i class="material-icons grey-text text-darken-3">archive</i>
                        </span>

                        <img src="assets/images/RTK_Haken.png" height="18" />
                    </div>
                </div>
            </li>
        </ul>
    </div>
</div>

<input id="takePictureField" type="file" capture="camera" accept="image/jpeg,image/png,application/pdf"
    (change)="takeImageCallback('takePictureField')" style="visibility:hidden;">
